export default "__VITE_ASSET__CHyz8kob__"